import { ContestSegmentType } from '@betterpool/api-types/contests-service';

import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';

function getIsContestSegmentedPayoutEnabled(contest: FullContest | Contest) {
  return contest.settings.segments?.segmentType === ContestSegmentType.MULTI_SLATE;
}

export default getIsContestSegmentedPayoutEnabled;
